import { DIALOG_DATA } from '@angular/cdk/dialog';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { SHARED_MODULES } from '@app/shared';
import { SidenavDailyShow } from './base';

@Component({
  imports: [SHARED_MODULES],
  templateUrl: './alert-daily.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AlertDailyComponent {
  public readonly data = inject<SidenavDailyShow>(DIALOG_DATA);
}
